export const renderShippingAddressLine = (value: string | null | undefined) => {
  if (!value) {
    return null
  }

  return <p className="m-0">{value}</p>
}
